/*
 * Log
 * ------------------------------------------------------------------------------------------------
 */
export const LOGS_ENABLED = process.env.NODE_ENV !== 'production';

export default class Log {
  static formatMessage(source, msg?: string) {
    if (typeof source === 'string' || source instanceof String) {
      return `[${source}] ${msg}`;
    }
    return `[${source.constructor.name}] ${msg}`;
  }

  static obj(obj: any) {
    if (LOGS_ENABLED) {
      console.log(obj); // eslint-disable-line no-console
    }
  }

  static info(source, msg?: string) {
    if (LOGS_ENABLED) {
      console.log(Log.formatMessage(source, msg)); // eslint-disable-line no-console
    }
  }

  static warn(source, msg?: string) {
    if (LOGS_ENABLED) {
      console.warn(Log.formatMessage(source, msg || '')); // eslint-disable-line no-console
    }
  }

  static error(source, msg?: string) {
    if (LOGS_ENABLED) {
      console.error(Log.formatMessage(source, msg)); // eslint-disable-line no-console
    }
  }
}
